import React from 'react';
import PropTypes from 'prop-types';
import ConfigAssistantFlatListView from './ConfigAssistantFlatListView';
import ConfigAssistantNestedListView from './ConfigAssistantNestedListView';
import { uniqBy, filter } from 'lodash';

const TrimsAndEnginesListView = props => {
  const {
    selectedDriveOption,
    selectedOption,
    options,
    flattened,
    renderHeader,
    onChange
  } = props;
  const { driveType } = selectedDriveOption;

  const optionsFilteredByDrive = filter(options, { driveType });

  const data = uniqBy(optionsFilteredByDrive, 'trimName')
    .map(({ trimName, driveType }) => ({
      id: trimName,
      header: renderHeader
        ? renderHeader({ trimName, driveType })
        : `${trimName}, ${driveType}`,
      options: filter(optionsFilteredByDrive, { trimName })
    }))
    .filter(x => x.options.length > 0);

  if (flattened) {
    return (
      <ConfigAssistantFlatListView
        data={data}
        selectedOption={selectedOption}
        onChange={onChange}
      />
    );
  }

  return (
    <ConfigAssistantNestedListView
      data={data}
      selectedOption={selectedOption}
      renderLabel={option => option.engineDescription}
      onChange={onChange}
    />
  );
};

TrimsAndEnginesListView.propTypes = {
  selectedDriveOption: PropTypes.object.isRequired,
  selectedOption: PropTypes.object,
  options: PropTypes.array.isRequired,
  flattened: PropTypes.bool,
  renderHeader: PropTypes.func,
  onChange: PropTypes.func.isRequired
};

export default TrimsAndEnginesListView;
